import downloadBinToFile from '../scripts/file_download'

AnalyticsCtrl.$inject = ['$scope', 'analyticsApi']

export default function AnalyticsCtrl($scope, analyticsApi) {
  $scope.getGoalAlignmentContentReport = function() {
    analyticsApi.getGoalAlignmentContentReport().then(function(data) {
      var today = new Date()
      var timestamp = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
      downloadBinToFile(data, timestamp + '-content_report.csv', 'application/csv')
    })
  }
}
